<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'FormItemLabelBox',
})
</script>
<template>
  <div :class="bem()">
    <div :class="bem('label', { required })">{{ label }}</div>
    <slot />
  </div>
</template>

<script lang="ts" setup name="FormItemLabelBox">
import { createNamespace } from '@bd/vue3-utils'

defineProps<{
  required?: boolean
  label?: string
}>()
const [_, bem] = createNamespace('FormItemLabelBox')
</script>

<style lang="less">
.form-item-label-box {
  margin-bottom: 32px;

  &__label {
    font-weight: 600;
    font-size: 14px;
    line-height: 42px;

    &--required::before {
      margin-right: 4px;
      color: @error-color;
      content: '*';
    }
  }
}
</style>
